import { SessionArticleEvent, SessionEvent } from '../ISessionEvent';

export class ArticleOpenedEvent extends SessionArticleEvent {
  constructor(articleId: string) {
    super('article-opened', articleId, {});
  }
}
